import NewMenu from './NewMenu';

export * from './types';
export default NewMenu;
